import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';

const headerHeight = 70;
const modalChangedW = 768;

function getWindowWidth(): number {
  return document.body.clientWidth;
}

@Component({
  selector: 'app-products',
  templateUrl: './products.component.html',
  styleUrls: ['./products.component.css']
})
export class ProductsComponent implements OnInit {
  @ViewChild('products') products: ElementRef;
  @ViewChild('aboutSystemBronir') aboutSystemBronir: ElementRef;

  isModalShowed = false;

  constructor(
    ) { }

  ngOnInit(): void {
  }

  scrollToAboutSystemBronir(): void {
    this.aboutSystemBronir.nativeElement.scrollIntoView(true);
    window.scrollBy(0, -headerHeight);
  }

  needScroll(): boolean {
    return getWindowWidth() <= modalChangedW;
  }

  openModal(): void {
    if (!this.isModalShowed && this.needScroll()) {
      this.scrollToAboutSystemBronir();
    }
    this.isModalShowed = !this.isModalShowed;
  }

  modalCloseHandler(): void {
    this.isModalShowed = false;
    if (this.needScroll()) {
      this.scrollToAboutSystemBronir();
    }
  }
}
